import React, { Fragment, useEffect, useContext, useState } from "react";
import { Link, Redirect } from "react-router-dom";

/* container */
import CMSContainer from "../../app-module-cms-container/default";
/* container */

/* form */
import LoginForm from "../form/login";
/* form */

/* packages */
import {
  ModuleContainerLg,
  ModulePaddedWrapperLg
} from "../../lib-atomic-design-section";
import { GlobalProvider } from "../../lib-atomic-context";
import LoginContainer from "../../app-module-login-container/default";
/* packages */

const index = props => {
  return (
    <GlobalProvider>
      <LoginContainer>
        <LoginForm {...props} />
      </LoginContainer>
    </GlobalProvider>
  );
};

export default index;
